<template>
  <SidebarLayout :classname="'section-np project-page'">
    <ProjectTopMenu :project="project" />
    <IncomingTenderAlertBlock />
    <router-view />
  </SidebarLayout>
</template>

<script>
  import { mapActions, mapMutations, mapState } from 'vuex';
  import SidebarLayout from '@/layouts/SidebarLayout';
  import ProjectTopMenu from '@/containers/top-menu/index';
  import IncomingTenderAlertBlock from '@/containers/incoming-tender/IncomingTenderAlertBlock';
  import incomingTender from '@/store/incoming-tender';
  import { addModule } from '@/store';

  export default {
    name: 'IncomingTender',
    components: {
      IncomingTenderAlertBlock,
      SidebarLayout,
      ProjectTopMenu,
    },
    created() {
      addModule('incomingTender', incomingTender);
      this.loadInfo();
    },
    computed: {
      ...mapState({
        project: (state) => state.incomingTender?.incomingTenderInfo?.tender?.project,
      }),
    },
    watch: {
      '$route.params.incomingTenderId': function () {
        this.clearIncomingTenderInfo();
        this.loadInfo();
      },
    },
    methods: {
      ...mapMutations('incomingTender', ['clearIncomingTenderInfo']),
      ...mapActions('incomingTender', ['loadIncomingTenderInfo']),
      async loadInfo() {
        const incomingTenderId = this.$route.params.incomingTenderId;
        await this.loadIncomingTenderInfo(incomingTenderId);
      },
    },
    destroyed() {
      this.clearIncomingTenderInfo();
    },
  };
</script>
